import $ from "jquery";

// Global viewer function that only works when the real viewer is available
window.viewer = function() {
    // Check if we're in an export context where the viewer is actually available
    if (typeof window.viewer_instance !== 'undefined' && window.viewer_instance) {
        return window.viewer_instance;
    }
    
    // Check if there's a viewer element and it has been initialized
    const viewerElement = $('#viewer');
    if (viewerElement.length > 0) {
        const viewerData = viewerElement.data('viewer');
        if (viewerData) {
            return viewerData;
        }
    }
    
    // Check for viewer in iframe (preview area)
    const previewIframe = $('#preview iframe');
    if (previewIframe.length > 0) {
        try {
            const iframeWindow = previewIframe[0].contentWindow;
            if (iframeWindow && iframeWindow.viewer) {
                return iframeWindow.viewer;
            }
        } catch (error) {
            // CORS or iframe not loaded - silently fail
        }
    }
    
    // If no real viewer is available, return null
    return null;
}; 